import React from "react";
import { Desktop } from "../containers/common";
import { Switch, Route, useRouteMatch } from "react-router-dom";

//screens
import BlackFridayHome from "../screens/subscriber/blackFriday/BlackFridayJumia";
import BlackFridayPickup from "../screens/subscriber/blackFriday/BlackFridayPickup";
import BlackFridayOrderDetails from "../screens/subscriber/blackFriday/BlackFridayOrderDetails";

const BlackFriday = () => {
  const match = useRouteMatch();
  return (
    <>
      <Desktop phonebg={"white"}>
        <Switch>
          <Route path={`${match.path}/pickup`} render={() => <BlackFridayPickup />} />
          <Route path={`${match.path}/order-details`} render={() => <BlackFridayOrderDetails />} />
          <Route path={`${match.path}/`} render={() => <BlackFridayHome />} />
        </Switch>
      </Desktop>
    </>
  );
};

export default BlackFriday;
